export const dataManagementRoutes = {
  basePath: '/app/data',

  keyspaces: 'keyspaces',
  auth: 'auth',
  buckets: 'buckets',
  upload: 'upload',
  manage: 'manage',
};
